import { mergePackageJson } from '../../file.js';
import { getCodeFormatOptions } from '../../format-code.js';
import { injectVitePlugin } from './replacers.js';
import { getAssetsDir } from '../../build.js';

async function setupVanillaExtract({
  rootDirectory
}) {
  const workPromise = Promise.all([
    mergePackageJson(await getAssetsDir("vanilla-extract"), rootDirectory),
    getCodeFormatOptions(rootDirectory).then(
      (formatConfig) => injectVitePlugin(rootDirectory, formatConfig, {
        path: "@vanilla-extract/vite-plugin",
        name: "vanillaExtractPlugin",
        isDefault: false
      })
    )
  ]);
  return {
    workPromise,
    generatedAssets: [],
    needsInstallDeps: true
  };
}

export { setupVanillaExtract };
